import React, { useState, useEffect, useContext } from 'react';
import Pagination from '@mui/material/Pagination';
import { GlobalContext } from 'store/context/GlobalContext';

export default function Giveaway() {
    const [ paginationParams, setPaginationParams ] = useState({count: 0, activePage: 1, itemsCountPerPage: 6});
    const context = useContext(GlobalContext);
    const { userData } = context;
    const [ data, setData ] = useState([]);

    useEffect(() => {
        if(userData.exchange_list.length > 0) {
            setPaginationParams({...paginationParams, count: userData.exchange_list.length});
            setData(userData.exchange_list.slice(0, paginationParams.itemsCountPerPage));
        }
    }, [userData])

    const handlePageChange = (event,idx) => {
        setPaginationParams({...paginationParams, activePage: idx});
        let newArray = userData.exchange_list.slice((idx-1)*paginationParams.itemsCountPerPage, idx*paginationParams.itemsCountPerPage);
        setData(newArray);
    }

    return (
        data.length > 0 ? (<>
            <div className="table-responsive">
                <table className="record-table giveaway-table">
                    <thead>
                        <tr>
                            <th>
                                <div>兌換日期</div>
                            </th>
                            <th>
                                <div>兌換項目</div>
                            </th>
                            <th>
                                <div>審核進度</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((item, index) => 
                                <tr key={index}>
                                    <td>{item.exchange_date}</td>
                                    <td className="giveaway-name">
                                        <div>{item.exchange_item}</div>
                                        <span className="mgx-1">|</span>
                                        <div>{item.exchange_point}點</div>
                                    </td>
                                    <td>{item.exchange_status_str}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            {
                paginationParams.count > 6 &&
                <div className="mgt-6 text-center">
                    <Pagination count={Math.ceil(paginationParams.count/paginationParams.itemsCountPerPage)} page={paginationParams.activePage} siblingCount={0} defaultPage={1} size="small" onChange={handlePageChange}/>
                </div>
            }
        </>) : (
            <div className="non-data">尚無獎品兌換紀錄</div>
        )
    )
}